import type { CashiersChipsWithdrawal } from '@/generated/graphql';

import { IAdmin, mapGQLAdmin } from './admin';

export interface ICashiersChipsWithdrawal {
  id: string;
  amount: number;
  createdAt: string;
  updatedAt: string;

  admin: IAdmin;
}

export interface ICashiersChipsWithdrawalTable {
  id: string;
  amount: number;
  createdAt: string;
  username: string;
}

export interface ICashiersChipsWithdrawalQueryVariable {
  first: number;
  after?: string;
  before?: string;
}

export function mapGQLCashiersChipsWithdrawal(gql_cashiersChipsWithdrawal?: CashiersChipsWithdrawal | null): ICashiersChipsWithdrawal {
  return {
    id: gql_cashiersChipsWithdrawal?.id ?? '',
    amount: gql_cashiersChipsWithdrawal ? gql_cashiersChipsWithdrawal.amount ?? 0 : 0,

    updatedAt: gql_cashiersChipsWithdrawal ? gql_cashiersChipsWithdrawal.updatedAt ?? new Date().toISOString() : new Date().toISOString(),
    admin: mapGQLAdmin(gql_cashiersChipsWithdrawal?.admin),
    createdAt: gql_cashiersChipsWithdrawal
      ? new Date(gql_cashiersChipsWithdrawal.createdAt).toLocaleString('en-US', {
          timeZone: 'Asia/Manila',
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          hour12: true,
          minute: '2-digit',
          hour: '2-digit',
        }) ?? ''
      : '',
  };
}
